import {ButtonProps} from 'antd';
import cn from 'classnames';
import {formatDistanceStrict} from 'date-fns';
import {ReactNode, useEffect, useState} from 'react';
import {BusyButton} from 'src/components';

export type WaitButtonProps = ButtonProps & {
  readyAt?: Date;
  readyClassName?: string;
  children: ReactNode | ((ready: boolean, timeLeft: string) => ReactNode);
};
export default function WaitButton(props: WaitButtonProps) {
  const {readyAt = new Date(), readyClassName, className, children, ...rest} = props;
  const [ready, setReady] = useState<boolean>(readyAt <= new Date());
  const [timeLeft, setTimeLeft] = useState<string>(formatDistanceStrict(new Date(), readyAt));

  useEffect(() => {
    let intervalId: NodeJS.Timer;
    if (!ready) {
      intervalId = setInterval(() => {
        const now = new Date();
        setTimeLeft(formatDistanceStrict(now, readyAt));
        if (readyAt <= now) {
          setReady(true);
        }
      }, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <BusyButton
      {...rest}
      disabled={!ready || props.disabled}
      className={cn(className, ready && readyClassName)}>
      {typeof children === 'function' ? children(ready, timeLeft) : children}
    </BusyButton>
  );
}
